var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{style:(_vm.styleWidth),attrs:{"value":_vm.showAlert,"type":"info","color":"cyan darken-2"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }